/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupResponse } from './OrganizationGroupResponse';
import {
    OrganizationGroupResponseFromJSON,
    OrganizationGroupResponseFromJSONTyped,
    OrganizationGroupResponseToJSON,
    OrganizationGroupResponseToJSONTyped,
} from './OrganizationGroupResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface OrganizationGroupResponsePagedResult
 */
export interface OrganizationGroupResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof OrganizationGroupResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<OrganizationGroupResponse>}
     * @memberof OrganizationGroupResponsePagedResult
     */
    data: Array<OrganizationGroupResponse> | null;
}

/**
 * Check if a given object implements the OrganizationGroupResponsePagedResult interface.
 */
export function instanceOfOrganizationGroupResponsePagedResult(value: object): value is OrganizationGroupResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function OrganizationGroupResponsePagedResultFromJSON(json: any): OrganizationGroupResponsePagedResult {
    return OrganizationGroupResponsePagedResultFromJSONTyped(json, false);
}

export function OrganizationGroupResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(OrganizationGroupResponseFromJSON)),
    };
}

export function OrganizationGroupResponsePagedResultToJSON(json: any): OrganizationGroupResponsePagedResult {
    return OrganizationGroupResponsePagedResultToJSONTyped(json, false);
}

export function OrganizationGroupResponsePagedResultToJSONTyped(value?: OrganizationGroupResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(OrganizationGroupResponseToJSON)),
    };
}

